import clsx from 'clsx';
import React from 'react';
import Nav from '@/components/navigation/Public';
import Footer from '@/components/legal/Footer';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const Layout = _ref => {
  let {
    className = '',
    children
  } = _ref;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: clsx(styles.container, className),
      children: [/*#__PURE__*/_jsx(Nav, {}), children, /*#__PURE__*/_jsx(Footer, {})]
    })
  });
};

export default Layout;
export { styles };